"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
function init() {
    document.addEventListener('lgm.attachment.opened', onOpenAttachment);
}
exports.init = init;
function onOpenAttachment(event) {
    var _a;
    if (!(event instanceof CustomEvent))
        return;
    if (!(event.target instanceof HTMLElement))
        return;
    (_a = event.target
        .closest('[data-attachment-container]')) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[data-read="false"]').forEach(function (element) {
        element === null || element === void 0 ? void 0 : element.classList.remove('bg-gray-200', 'font-bold');
    });
}
